import { APP } from '../constants';
import Logo from './Logo';
import { colors } from '../theme';

/**
 * Brand splash. Shown while the stored session is restored on first load, and
 * again for a beat whenever the portal boots cold - the same moment the app
 * shows its own splash.
 */
const Splash = ({ leaving }) => (
  <div className={`splash ${leaving ? 'splash-out' : ''}`}>
    <div className="pop">
      <Logo size={116} />
    </div>

    <div className="reveal" style={{ animationDelay: '160ms', textAlign: 'center' }}>
      <div
        style={{
          fontSize: 34, fontWeight: 800, letterSpacing: 1,
          color: colors.primary, marginTop: 16,
        }}
      >
        {APP.name}
      </div>
      <div className="t-small" style={{ marginTop: 4, letterSpacing: 0.6 }}>{APP.tagline}</div>
    </div>

    <div className="splash-track"><div className="splash-fill" /></div>

    <div className="t-tiny splash-motto">{APP.motto}</div>
  </div>
);

export default Splash;
